import React from 'react';
import {OnChange} from 'react-final-form-listeners';
import {useIntl} from 'react-intl';

import Field from 'brandComponents/Form/Subcomponents/Field';

import {IReturnFieldProps} from './IReturnField';
import messages from './messages';

import styles from './ReturnField.module.scss';

const ReturnField = ({
	itemKey,
	returnReasonSelected,
	setReturnReasonSelected,
}: IReturnFieldProps) => {
	const intl = useIntl();

	return (
		<div className={styles['return-create-step-1__checkbox']}>
			<Field
				name={`returnProduct-${itemKey}`}
				type="checkbox"
				label={intl.formatMessage(messages.returnCheckboxLabel)}
				classNamesCntr={styles['return-create-step-1__checkbox']}
				classNames={styles['return-product__label']}
				component="input"
			/>

			<OnChange name={`returnProduct-${itemKey}`}>
				{(value) => {
					if (!value) {
						setReturnReasonSelected({
							...returnReasonSelected,
							[itemKey]: '',
						});
					}
				}}
			</OnChange>
		</div>
	);
};

export default ReturnField;